import _ from 'lodash';
import Promise from 'bluebird';

export default function ({ state, actions, effects }, instance) {
  
}
